import { createContext } from 'react'

export const StyledModalContext = createContext()
